import React from 'react';
import { Path, Rect, Svg } from 'react-native-svg';

export interface ChevronRightBadgeIconProps {
    size?: number;
    disabled?: boolean;
    arrowColor?: string;
    bgColor?: string;
}

export const ChevronRightBadgeIcon: React.FC<ChevronRightBadgeIconProps> = ({
    size = 20,
    disabled = false,
    arrowColor,
    bgColor,
}) => {
    const finalBg = bgColor ?? '#EEE';
    const finalArrow = arrowColor ?? (disabled ? '#999' : '#333');
    return (
        <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
            <Rect width={20} height={20} fill={finalBg} rx={10} />
            <Path
                fill={finalArrow}
                d="M10.602 10 7.526 6.924l.936-.937L12.474 10l-4.012 4.012-.936-.936L10.602 10"
            />
        </Svg>
    );
};

export default ChevronRightBadgeIcon;
